export default __webpack_public_path__ + "static/media/Ikhlas.331279d4.mp3";